import { TherapistAction } from 'src/redux/actions/constant';

const { SUCCESS_GET_ALL_THERAPIST, FAILURE_GET_ALL_THERAPIST, LOADING_GET_ALL_THERAPIST } =
  TherapistAction;

const intialState: any = {
  response: null,
  rows: [],
  isLast: false,
  isSuccess: false,
  loading: false,
};

const rowsOf = (data: any): any[] =>
  Array.isArray(data) ? data : Array.isArray(data?.content) ? data.content : [];

export const getAllTherapistsByRoleReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case SUCCESS_GET_ALL_THERAPIST: {
      const data = action.payload?.data;
      const page = action.requestedPage ?? data?.number ?? 0;
      const previous = page > 0 && Array.isArray(state.rows) ? state.rows : [];
      return {
        ...state,
        response: data,
        rows: [...previous, ...rowsOf(data)],
        isLast: Array.isArray(data) ? true : !!data?.last,
        isSuccess: true,
        loading: false,
      };
    }

    case FAILURE_GET_ALL_THERAPIST:
      return {
        ...state,
        response: action.payload,
        isSuccess: false,
        loading: false,
      };

    case LOADING_GET_ALL_THERAPIST:
      return { ...state, loading: true };

    default:
      return state;
  }
};
